import BankDeleteModal from "./BankDeleteModal";

export default BankDeleteModal;
